export default function isActiveBlock(editor, blockTypes) {
  var comparator = blockTypes && blockTypes.constructor === Array ? function (block) {
    return blockTypes.includes(block.type);
  } : function (block) {
    return block.type === blockTypes;
  };
  return editor.value.blocks.every(comparator);
}